// @generated by protoc-gen-es v2.10.2 with parameter "target=ts"
// @generated from file inventory/v1/documentation.proto (package inventory.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file inventory/v1/documentation.proto.
 */
export const file_inventory_v1_documentation: GenFile = /*@__PURE__*/
  fileDesc("CiBpbnZlbnRvcnkvdjEvZG9jdW1lbnRhdGlvbi5wcm90bxIMaW52ZW50b3J5LnYxIk8KDURvY3VtZW50YXRpb24SCgoCaWQYASABKAkSEwoLZGVzY3JpcHRpb24YAiABKAkSDAoEcmlzaxgDIAEoCRIPCgdhY3Rpb25zGAQgAygJQroBChBjb20uaW52ZW50b3J5LnYxQhJEb2N1bWVudGF0aW9uUHJvdG9QAVpBZ2l0aHViLmNvbS9sZW1hLmFpL2xlbW1hdGEvYXBpL3Byb3RvL2dlbi9pbnZlbnRvcnkvdjE7aW52ZW50b3J5djGiAgNJWFiqAgxJbnZlbnRvcnkuVjHKAgxJbnZlbnRvcnlcVjHiAhhJbnZlbnRvcnlcVjFcR1BCTWV0YWRhdGHqAg1JbnZlbnRvcnk6OlYxYgZwcm90bzM");

/**
 * @generated from message inventory.v1.Documentation
 */
export type Documentation = Message<"inventory.v1.Documentation"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string description = 2;
   */
  description: string;

  /**
   * explains what might happen if the risk factor is not mitigated
   *
   * @generated from field: string risk = 3;
   */
  risk: string;

  /**
   * possible actions to mitigate the risk
   *
   * @generated from field: repeated string actions = 4;
   */
  actions: string[];
};

/**
 * Describes the message inventory.v1.Documentation.
 * Use `create(DocumentationSchema)` to create a new message.
 */
export const DocumentationSchema: GenMessage<Documentation> = /*@__PURE__*/
  messageDesc(file_inventory_v1_documentation, 0);

